import { callApiToServer } from "../callApi";

export async function getDepartments(Token, skip, limit) {
  try {
    let headers = {
      Authorization: `Bearer ${Token}`,
    };

    let endUrl = `v1/auth/admin/department/0/20`;

    const response = await callApiToServer(null, headers, "GET", endUrl);

    console.log("Get Departments Response:", response);
    return response;
  } catch (err) {
    console.error("Get Departments Error:", err);
    throw err;
  }
}

export async function getDepartmentDetails(Token, id) {
  try {
    let headers = {
      Authorization: `Bearer ${Token}`,
    };

    let endUrl = `v1/auth/admin/department-details/${id}`;

    const response = await callApiToServer(null, headers, "GET", endUrl);

    console.log("Get Department Details Response:", response);
    return response;
  } catch (err) {
    console.error("Get Department Details Error:", err);
    throw err;
  }
}

export async function revokeDepartmentCourse(Token, payload) {
  try {
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Token}`,
    };

    let endUrl = `v1/auth/admin/department/revoke-course`;
    const body = JSON.stringify(payload);

    const response = await callApiToServer(body, headers, "DELETE", endUrl);

    console.log("Revoke Department Course Response:", response);
    return response;
  } catch (err) {
    console.error("Revoke Department Course Error:", err);
    throw err;
  }
}

export async function revokeDepartmentUser(Token, payload) {
  try {
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Token}`,
    };

    let endUrl = `v1/auth/admin/department/revoke-user`;
    const body = JSON.stringify(payload);

    const response = await callApiToServer(body, headers, "DELETE", endUrl);

    console.log("Revoke Department User Response:", response);
    return response;
  } catch (err) {
    console.error("Revoke Department User Error:", err);
    throw err;
  }
}
